<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧社区</h2>
        <h3>社区电瓶车智能充电桩解决方案</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <div>
          <h2>社区电瓶车智能充电桩解决方案</h2>
          <p>电瓶车充电站通过GPRS模块与云端进行通信和数据交互。系统能够对电 瓶车充电桩的日常状态、充电过程进行监控；实现支付对接： 能够支持投币、刷卡微信等多种支付方式；必 须保证支付过程交易的完整性，对充电过程中的异常情况进行有效处理； 实对下游站级平台的清算、对账功能 。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScelectricCarpile',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
</style>
